import AgendaEmailAddress from "./AgendaEmailAddress";

type AgendaItemOrganizerProps = {
    emailAddress: AgendaEmailAddress;
};

export default class AgendaItemOrganizer {
    emailAddress: AgendaEmailAddress;

    constructor({ emailAddress }: AgendaItemOrganizerProps) {
        this.emailAddress = emailAddress;
    }
}
